<template>
  <div class="bid common-bg padding-nav ">
    <el-row class="bid-body">
      <!-- <el-col :md="13" :lg="13">
        <div class="bid-left">
          <div class="bid-title">Bidding data</div>
          <leftTime @refreshTime="refreshTime"/>
          <leftChart ref="leftChart"/>
        </div>
      </el-col>
      <el-col :md="11" :lg="11">
        <div class="spaceCenter bid-right">

        </div>
      </el-col> -->
      <topTime @refreshTime="refreshTime" />
      <bidNow
        ref="bidNow"
        @setShowDetail="setShowDetail"
        @refresh="refresh"
        @refreshChart="refreshChart"
      />
    </el-row>
    <detail-comp v-if="showDetail" ref="bidDetail" style="margin-top:1.6rem" />
  </div>
</template>

<script>
import leftTime from "./components/leftTime.vue";
import topTime from "./components/topTime.vue";
import bidNow from "./components/bidNow.vue";
import detailComp from "./detail.vue";
export default {
  components: { leftTime, topTime, bidNow, detailComp },
  data() {
    return {
      showDetail: false
    };
  },
  computed: {},
  methods: {
    setShowDetail() {
      this.showDetail = true;
      this.$nextTick(() => {
        this.refresh();
      });
    },
    refresh() {
      this.$refs.bidDetail && this.$refs.bidDetail.refresh();
      this.$refs.leftChart.init();
    },
    refreshChart() {
      this.$refs.leftChart.init();
    },
    refreshTime() {
      console.log("refreshTime");
      if (this.$store.getters.metaMaskObj.account) {
        this.$refs.bidNow.refreshCurrentcumulativebid();
        this.$refs.leftChart.refreshChart();
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style scoped lang="scss">
.bid {
  .bid-body {
    width: 90%;
    margin: 0 auto;
  }
  .bid-left {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 0.4rem;
    padding: 0.48rem 0.8rem;
  }
  .bid-right {
    min-height: 8.64rem;
  }
  .bid-title {
    font-size: 0.32rem;
    font-weight: 500;
    color: #1f1f1f;
    line-height: 0.38rem;
    margin-bottom: 0.4rem;
  }
}
</style>
